module.exports = __webpack_public_path__ + "static/media/user-access-management.099e5af5.jpg";